/**
 * 문제집 Excel 업로드 페이지
 * - ZIP 파일 업로드 (Excel + 정답 이미지)
 * - WorkbookUpload 컴포넌트 렌더링
 */

import React from 'react';
import { Card } from 'antd';
import { WorkbookUpload } from '../../components/Upload/WorkbookUpload';

/**
 * UploadPage 컴포넌트
 * 문제집 ZIP 파일 업로드 페이지
 */
export const UploadPage: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card title="문제집 Excel 업로드">
        <WorkbookUpload />
      </Card>
    </div>
  );
};
